import React from 'react';
import { useAuth } from '../middleware/AuthContext'; // Import the useAuth hook
import Button from '../components/Button'; // Assuming Button component is already defined

const UnauthorizedPage: React.FC = () => {
  const { login } = useAuth(); // Use auth context
  return (
    <div className="flex justify-center items-center h-screen bg-gray-100">
      <div className="text-center">
        <h1 className="text-5xl font-bold text-red-500">401 Unauthorized</h1>
        <p className="text-lg">You are not authorized to view this page.</p>
        <div className="space-y-3">
          <Button variant="primary"  onClick={() => login()} >
            Go to Login as Subscriber
          </Button>
          </div>
          <div className="space-y-10 mt-3">
          <Button variant="primary" onClick={() => login('msal')} >
            Go to Login as Sender
          </Button>
        </div>
      </div>
    </div>
  );
};

export default UnauthorizedPage;
